import { autoinject } from 'aurelia-framework';

@autoinject
export class Unauthorized {
 
  constructor() {
   
  }

  bind(bindingContext: any, overrideContext: any) {
   
  }

  attached() {
    
  }

  detached() {
   
  }

}